
import React from 'react';
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { 
  Select, 
  SelectContent, 
  SelectItem, 
  SelectTrigger, 
  SelectValue 
} from "@/components/ui/select";
import { PolicyType } from '../types/PolicyTypes';

interface FixedDepositPolicySectionProps {
  policy: PolicyType;
  setPolicy: React.Dispatch<React.SetStateAction<PolicyType>>;
  isEditing: boolean;
}

const FixedDepositPolicySection = ({ policy, setPolicy, isEditing }: FixedDepositPolicySectionProps) => {
  return (
    <div>
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-medium">Fixed Deposit Policy</h3>
        <div className="flex items-center space-x-2">
          <Label htmlFor="fdEnabled">Enable Fixed Deposits</Label>
          <Switch 
            id="fdEnabled"
            checked={policy.fixedDeposit.enabled}
            onCheckedChange={(checked) => setPolicy({
              ...policy,
              fixedDeposit: {
                ...policy.fixedDeposit,
                enabled: checked
              }
            })}
            disabled={!isEditing}
          />
        </div>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="space-y-2">
          <Label htmlFor="fdMaxPercentage">Maximum Allocation in FDs (%)</Label>
          <Input 
            id="fdMaxPercentage" 
            type="number" 
            value={policy.fixedDeposit.maxPercentage} 
            onChange={(e) => setPolicy({
              ...policy,
              fixedDeposit: {
                ...policy.fixedDeposit,
                maxPercentage: parseFloat(e.target.value)
              }
            })}
            disabled={!isEditing || !policy.fixedDeposit.enabled}
          />
        </div>
        <div className="space-y-2">
          <Label htmlFor="fdMinRating">Minimum Bank Rating</Label>
          <Select 
            defaultValue={policy.fixedDeposit.minRating}
            disabled={!isEditing || !policy.fixedDeposit.enabled}
            onValueChange={(value) => setPolicy({
              ...policy,
              fixedDeposit: {
                ...policy.fixedDeposit,
                minRating: value
              }
            })}
          >
            <SelectTrigger id="fdMinRating">
              <SelectValue placeholder="Select minimum rating" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="AAA">AAA</SelectItem>
              <SelectItem value="AA+">AA+</SelectItem>
              <SelectItem value="AA">AA</SelectItem>
              <SelectItem value="A+">A+</SelectItem>
              <SelectItem value="A">A</SelectItem>
            </SelectContent>
          </Select>
        </div>
        <div className="space-y-2">
          <Label htmlFor="fdMaxTenor">Maximum Tenor (months)</Label>
          <Input 
            id="fdMaxTenor" 
            type="number" 
            value={policy.fixedDeposit.maxTenor} 
            onChange={(e) => setPolicy({
              ...policy,
              fixedDeposit: {
                ...policy.fixedDeposit,
                maxTenor: parseInt(e.target.value)
              }
            })}
            disabled={!isEditing || !policy.fixedDeposit.enabled}
          />
        </div>
        <div className="space-y-2">
          <Label htmlFor="fdMinRate">Minimum Interest Rate (%)</Label>
          <Input 
            id="fdMinRate" 
            type="number" 
            step="0.01"
            value={policy.fixedDeposit.minInterestRate} 
            onChange={(e) => setPolicy({
              ...policy,
              fixedDeposit: {
                ...policy.fixedDeposit,
                minInterestRate: parseFloat(e.target.value)
              }
            })}
            disabled={!isEditing || !policy.fixedDeposit.enabled}
          />
        </div>
      </div>
    </div>
  );
};

export default FixedDepositPolicySection;
